import { render, staticRenderFns } from "./Hive.vue?vue&type=template&id=2b022336&scoped=true&"
import script from "./Hive.vue?vue&type=script&lang=js&"
export * from "./Hive.vue?vue&type=script&lang=js&"
import style0 from "./Hive.vue?vue&type=style&index=0&id=2b022336&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b022336",
  null
  
)

export default component.exports